import { Box, CircularProgress, Grid, Typography, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import DatePicker from '../../../components/datepicker/DatePicker';
import GetSiteRec from '../../../components/api/GetSiteRec';
import DataUnavailable from '../../../components/data/DataUnavailable';
import { useSite } from '../../../components/siteselector/SiteContext';
import { useDate } from '../../../components/datepicker/DateContext';
import { tokens } from '../../../theme';
import BoltIcon from '@mui/icons-material/Bolt';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import SkySparkGrid from '../../../components/api/SkySparkGrid';
import { WeekDayChart, ElecBaseloadChart } from '../../../components/charts/ems';
import GetParam from '../../../components/api/GetParam';
import LoginCookieAuth from '../../../components/api/LoginCookieAuth';
import Cookies from 'js-cookie';
import GetUser from '../../../components/api/GetUser';

function BaseloadScene() {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { siteId } = useParams();
    const [siteName, setSiteName] = useState("");
    const [lineData, setLineData] = useState([]);
    const [elecBaseLoadData, setElecBaseloadData] = useState([]);
    const [, setSiteRec] = useState({});
    const { selectedSite } = useSite();
    const { selectedDate } = useDate();
    const navigate = useNavigate();
    const [lineValid, setLineValid] = useState(false);
    const [lineLoading, setLineLoading] = useState(true);
    const [elecDataLoading, setElecDataLoading] = useState(true)
    const location = useLocation()
    const [pageAcces, SetPageAcces] = useState(false)

    useEffect(() => {
        GetUser().then((response) => {
            const pageWhitelist = response.data["rows"][0].infSiteModules
            if(pageWhitelist.includes('ems/baseload')) {
              SetPageAcces(true)
            } else {
              navigate('/projects')
            }
        });
        LoginCookieAuth(Cookies.get('skyarc-auth-8080')).then(async(authResponse) => {
        if(authResponse) {
            const dateRange = GetParam('dateRange', location)
            if (!lineLoading || !elecDataLoading) {
                setLineLoading(true)
                setElecBaseloadData(true)
            }
            SkySparkGrid(`testElec(@${siteId}, ${dateRange})`).then((response) => {
                if (response.data['rows'].length === 0 || response.data["meta"]["sampleCount"] <= 1) {
                    setLineValid(false)
                    setLineLoading(false)
                } else {
                    setLineValid(true)
                    const responseVal = response.data["rows"]
                    setLineData((<WeekDayChart dataValues={responseVal} />))
                    setLineLoading(false)
                }
            })
    
            SkySparkGrid(`testElecBaseload(@${siteId}, ${selectedDate[0].dateString})`).then((response) => {
                if (response.data['rows'].length === 0 || response.data["meta"]["sampleCount"] <= 1) {
                    setLineValid(false)
                    setElecDataLoading(false)
                } else {
                    setLineValid(true)
                    const responseVal = response.data["rows"]
                    setElecBaseloadData((<ElecBaseloadChart dataValues={responseVal} />))
                    setElecDataLoading(false)
                }
            })
    
            if (siteId !== "undefined") {
                GetSiteRec(siteId).then((response) => {
                    const responseVal = response.data["rows"][0]
                    setSiteRec(responseVal)
                    setSiteName(responseVal['navName'])
                })
            }
            //scroll after navigating
            document.getElementById('content').scrollTo(0, 0)
        }
    })
        // eslint-disable-next-line
    }, [navigate, siteId, siteName, selectedSite, selectedDate]);

    return (
        <>
        {
            pageAcces ? (
            <Box m="18px" maxWidth="100%">

            {/* TOP ROW - BUTTONS*/}
            <Box display="grid" sx={{ p: "0 0 18px 0", display:'flex' }}>
                <DatePicker />
            </Box>
            <Grid container gap={2} wrap='nowrap' direction={{ xs: "column", sm: "column", md: "column", lg: "column", xl: "row" }}>
                <Grid item xl={8}>
                    <Box minHeight='300px' maxWidth={{ xl: '1362px', lg: '1193px' }} backgroundColor={colors.primary[400]}>
                        <Grid container wrap='nowrap' direction={{ xl: 'row', lg: 'column', md: 'column', sm: 'column', xs: 'column' }}>
                            <Grid item xl={1} backgroundColor={colors.greenAccent[500]} minHeight={{ xl: '200px', lg: '100px' }} minWidth='140px' display='flex'>
                                <BoltIcon sx={{ width: '75px', height: '75px', margin: 'auto' }} />
                            </Grid>
                            <Grid item xl={6}>
                                <Box sx={{ height: '300px', p: '5px', maxWidth: { xl: '98%', lg: '100%' } }}>
                                    {
                                        lineLoading ? (<Box sx={{ display: 'flex', justifyContent: 'center', mt: '130px' }}><CircularProgress style={{ 'color': 'gray', opacity: '0.5' }} /></Box>) : (lineValid ? lineData : <DataUnavailable />)
                                    }
                                </Box>
                            </Grid>
                            <Grid item xl={5}>
                                <Box sx={{ maxWidth: { xl: '98%' }, height: '300px', minHeight: '300px', maxHeight: '300px', p: '15px' }}>
                                    {
                                        elecDataLoading ? (<Box sx={{ display: 'flex', justifyContent: 'center', mt: '130px' }}><CircularProgress style={{ 'color': 'gray', opacity: '0.5' }} /></Box>) : (lineValid ? elecBaseLoadData : <DataUnavailable />)
                                    }
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>
                <Grid item xl={3} lg={12}>
                    <Typography fontWeight='bold' fontSize={17} color='secondary' textAlign='center'>Baseload-Elektra</Typography>
                    <Typography fontWeight='bold' fontSize={14} textAlign='center'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras vel eros augue. Nullam id porttitor arcu, ut volutpat arcu. Nulla in ligula eros. Aliquam consequat euismod nulla, sit amet aliquet augue ornare ac. Cras venenatis vehicula eros vitae congue. Curabitur quis massa sollicitudin, feugiat eros sit amet, rhoncus nulla. Sed hendrerit nisl eget viverra condimentum.
                        Cras quis diam dignissim, hendrerit erat vitae, posuere diam. Curabitur laoreet, tortor nec tristique hendrerit, enim nibh interdum eros, eget elementum dui purus at justo. Vivamus sollicitudin ultricies neque, non semper arcu posuere sed. Nunc diam lacus, euismod quis magna id, bibendum feugiat tellus. Praesent pretium, tortor ut posuere mollis, urna diam molestie sem, sed egestas risus nibh eu eros. Vestibulum non lacus ex. Aliquam sed libero posuere, maximus eros sed, dapibus magna. Aenean sit amet tortor fermentum, pellentesque urna sed, molestie orci.</Typography>
                </Grid>
            </Grid>
            <br />
            <Grid container gap={2} wrap='nowrap' direction={{ xs: "column", sm: "column", md: "column", lg: "column", xl: "row" }}>
                <Grid item xl={8}>
                    <Box minHeight='300px' maxWidth={{ xl: '1362px', lg: '1193px' }} backgroundColor={colors.primary[400]}>
                        <Grid container wrap='nowrap' direction={{ xl: 'row', lg: 'column', md: 'column', sm: 'column', xs: 'column'}}>
                            <Grid item xl={1} backgroundColor={colors.greenAccent[500]} minHeight={{ xl: '200px', lg: '100px' }} minWidth='140px' display='flex'>
                                <LocalFireDepartmentIcon sx={{ width: '75px', height: '75px', margin: 'auto' }} />
                            </Grid>
                            <Grid item xl={6}>
                                <Box sx={{ height: '300px', p: '5px', maxWidth: { xl: '98%', lg: '100%' } }}>
                                    {
                                        lineLoading ? (<Box sx={{ display: 'flex', justifyContent: 'center', mt: '130px' }}><CircularProgress style={{ 'color': 'gray', opacity: '0.5' }} /></Box>) : (lineValid ? lineData : <DataUnavailable />)
                                    }
                                </Box>
                            </Grid>
                            <Grid item xl={5}>
                                <Box sx={{ maxWidth: { xl: '98%' }, height: '300px', minHeight: '300px', maxHeight: '300px', p: '15px' }}>
                                    {
                                        elecDataLoading ? (<Box sx={{ display: 'flex', justifyContent: 'center', mt: '130px' }}><CircularProgress style={{ 'color': 'gray', opacity: '0.5' }} /></Box>) : (lineValid ? elecBaseLoadData : <DataUnavailable />)
                                    }
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>
                <Grid item xl={3} lg={12}>
                    <Typography fontWeight='bold' fontSize={17} color='secondary' textAlign='center'>Baseload-Gas</Typography>
                    <Typography fontWeight='bold' fontSize={14} textAlign='center'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras vel eros augue. Nullam id porttitor arcu, ut volutpat arcu. Nulla in ligula eros. Aliquam consequat euismod nulla, sit amet aliquet augue ornare ac. Cras venenatis vehicula eros vitae congue. Curabitur quis massa sollicitudin, feugiat eros sit amet, rhoncus nulla. Sed hendrerit nisl eget viverra condimentum.
                        Cras quis diam dignissim, hendrerit erat vitae, posuere diam. Curabitur laoreet, tortor nec tristique hendrerit, enim nibh interdum eros, eget elementum dui purus at justo. Vivamus sollicitudin ultricies neque, non semper arcu posuere sed. Nunc diam lacus, euismod quis magna id, bibendum feugiat tellus. Praesent pretium, tortor ut posuere mollis, urna diam molestie sem, sed egestas risus nibh eu eros. Vestibulum non lacus ex. Aliquam sed libero posuere, maximus eros sed, dapibus magna. Aenean sit amet tortor fermentum, pellentesque urna sed, molestie orci.</Typography>
                </Grid>
            </Grid>
        </Box>
            ) : (
              null
            )
        }
        </>
    )
}

export default BaseloadScene
